import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Center, Tooltip,
} from '@mantine/core';

import { NARROW_COLUMN_STYLES } from './constants';

export default function useColColorSchema({ accessor }) {
    const colDeleteSchema = {
        accessor,
        style: NARROW_COLUMN_STYLES,
        title: (
            <Center>
                <FontAwesomeIcon icon="palette" />
            </Center>
        ),
        render: ({ row }) => (
            <Tooltip label={row[accessor]}>
                <Center>
                    <FontAwesomeIcon color={`#${row[accessor]}`} stroke="#000" stroke-width="20px" icon="palette" />
                </Center>
            </Tooltip>
        ),
    };

    return colDeleteSchema;
}
